import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Trophy } from "lucide-react";

const MEDALS = ["🥇", "🥈", "🥉"];

function badgesFor(r, i, rows) {
  const b = [];
  if (i === 0 && r.total > 0) b.push("👑 Roi du salon");
  const maxHot = Math.max(...rows.map((x) => x.hot));
  if (maxHot > 0 && r.hot === maxHot) b.push("🔥 Chasseur de chauds");
  if (r.total >= 10) b.push("⚡ 10+ leads");
  return b;
}

export default function LeaderboardCard({ event = "" }) {
  const [scope, setScope] = useState("today");
  const [data, setData] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () => api.get("/leaderboard", { params: { event, scope } }).then(({ data }) => alive && setData(data)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => { alive = false; clearInterval(t); };
  }, [scope, event]);

  const rows = data?.rows || [];
  return (
    <div className="rounded-2xl bg-card p-5 shadow-[0_8px_30px_-16px_rgba(15,23,42,0.18)]" data-testid="team-leaderboard">
      <div className="flex items-center justify-between gap-2">
        <p className="font-heading font-bold flex items-center gap-2 whitespace-nowrap"><Trophy className="w-4 h-4 text-amber-500" /> Classement équipe <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" title="En direct" /></p>
        <div className="inline-flex p-0.5 rounded-full bg-secondary text-xs font-semibold">
          {[["today", "Jour"], ["all", "Salon"]].map(([k, l]) => (
            <button key={k} onClick={() => setScope(k)} data-testid={`leaderboard-scope-${k}`} className={`h-7 px-3 rounded-full whitespace-nowrap transition-colors ${scope === k ? "bg-card shadow-sm text-foreground" : "text-muted-foreground"}`}>{l}</button>
          ))}
        </div>
      </div>
      {event && <p className="text-xs text-muted-foreground mt-1">{event}</p>}
      {rows.length === 0 ? <p className="text-sm text-muted-foreground text-center py-6">Aucun lead pour l'instant — soyez le premier ! 🏁</p> : (
        <ol className="mt-3 space-y-2">
          {rows.slice(0, 10).map((r, i) => (
            <li key={r.ownerId} data-testid={`team-leaderboard-row-${i}`} className={`flex items-center gap-3 rounded-xl p-2.5 ${r.ownerId === data.meId ? "bg-gradient-to-r from-[#A855F7]/10 to-[#EC4899]/10" : ""}`}>
              <span className="w-7 text-center text-lg">{MEDALS[i] || <span className="text-sm font-bold text-muted-foreground">{i + 1}</span>}</span>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold truncate">{r.ownerName}{r.ownerId === data.meId ? " (vous)" : ""}</p>
                <div className="flex flex-wrap gap-1 mt-0.5">{badgesFor(r, i, rows).map((b) => <span key={b} className="text-[10px] font-bold rounded-full px-2 py-0.5 bg-amber-500/15 text-amber-700">{b}</span>)}</div>
              </div>
              <span className="font-heading font-extrabold tabular-nums" data-testid={`team-leaderboard-total-${i}`}>{r.total}</span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
